/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

/** All known types for project data */
export enum ProjectTypes {
	DISABLED = 'disabled',
	ENTERPRISE = 'enterprise',
	INVOCIE = 'invoice',
	INVOICE_EXPIRED = 'invoiceExpired',
	OPEN_BETA = 'openBeta',
	BETA_60 = 'beta60',
	TRIALING = 'trialing',
	TRIAL_EXPIRED = 'trialExpired',
	PAID = 'paid',
	DELINGQUENT = 'delinquent',
	CANCELED = 'canceled',
	CANCEL_AT_PERIOD_END = 'cancelAtPeriodEnd',
	SAMPLE_PROJECT = 'sampleProject',
	PERSONAL_PLANNING = 'personalPlanning',
	PERSONAL_PLAN_V1 = 'personalPlanV1',
	SAMPLE_PROJECT_SHARED = 'sampleProjectShared',
	UNKNOWN = 'unknown',
}

const disabledTypes: ProjectTypes[] = [
	ProjectTypes.DISABLED,
	ProjectTypes.INVOICE_EXPIRED,
	ProjectTypes.TRIAL_EXPIRED,
	ProjectTypes.CANCELED,
];

const sampleProjectTypes: ProjectTypes[] = [
	ProjectTypes.BETA_60,
	ProjectTypes.OPEN_BETA,
	ProjectTypes.SAMPLE_PROJECT,
	ProjectTypes.PERSONAL_PLANNING,
	ProjectTypes.PERSONAL_PLAN_V1,
	ProjectTypes.SAMPLE_PROJECT_SHARED,
];

export function isProjectTypeSampleProject(type: ProjectTypes): boolean {
	return sampleProjectTypes.includes(type);
}

export function isProjectTypeArchived(type: ProjectTypes): boolean {
	return disabledTypes.includes(type) || sampleProjectTypes.includes(type);
}

export function isProjectTypeDisabled(type: ProjectTypes): boolean {
	return isProjectTypeArchived(type);
}
